import { useQuery } from '@tanstack/react-query';

import { getRoomImages } from '~/services/AccommodationService';

export const roomImagesQueryKeys = {
  all: ['accommodation', 'room-images'] as const,
  details: () => [...roomImagesQueryKeys.all, 'detail'] as const,
  detail: (roomId: string) => [...roomImagesQueryKeys.details(), roomId] as const,
};

export function useGetRoomImages({ roomId, enabled = true }: { roomId: string; enabled?: boolean }) {
  return useQuery({
    queryKey: roomImagesQueryKeys.detail(roomId),
    queryFn: async ({ signal }) => {
      const response = await getRoomImages({ roomId, signal });
      return response.result;
    },
    enabled: enabled && !!roomId,
  });
}
